import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { CommonComponentsModule } from '../../../../../../../SUVO-CORE-CLIENT-LIB/projects/suvo-core-client-lib/src/lib/features/common-components/common-components.module';
import { SharedModule } from '../../shared/shared.module';
import { TileCreatorModule } from '../tile-creator/tile-creator.module';
import { SkeletonGridComponent } from './components/skeleton-grid/skeleton-grid.component';
import { SmartGridComponent } from './components/smart-grid/smart-grid.component';
import { TileJsonDialogComponent } from './components/tile-json-dialog/tile-json-dialog.component';
import { TimestampsToolbarComponent } from './components/timestamps-toolbar/timestamps-toolbar.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    NgxSkeletonLoaderModule,
    CommonComponentsModule,
    TileCreatorModule,
    MatTooltipModule,
  ],
  declarations: [
    SmartGridComponent,
    TimestampsToolbarComponent,
    TileJsonDialogComponent,
    SkeletonGridComponent,
  ],
  exports: [SmartGridComponent, SkeletonGridComponent, TimestampsToolbarComponent],
})
export class SmartGridModule {}
